import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import NotificationTable from './components/Table';

import { Service } from '../service';
import { tab } from './handle/tab.handle';
import Loading from '../../../v2-components/Loading';
import useNotificationStore from '../store/useNotificationStore';
import { handleSearchParams } from './handle/search-params.handle';
import { removeNotificationsFromCache } from '../../../_config/functions/save-read-notificacations-on-storage';

export default function NotificationsListPage() {
	console.log('NotificationsListPage');
	const history = useHistory();
	const location = useLocation();
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [selectedPharmacy, setSelectedPharmacy] = useState(null);
	const [selectedNotificationType, setSelectedNotificationType] = useState(null);
	const [dataSource, setDataSource] = useState([]);
	const [user] = useState(GetLocalStorageValue('userInfo'));
	const [orderBy, setOrderBy] = useState(null);
	const searchParams = new URLSearchParams(location?.search);
	const [forceRefetch, setForceRefetch] = useState(false);
	const statusQueryParam = searchParams.get('seen');
	const [seen, setSeen] = useState(statusQueryParam === 'true' ? true : statusQueryParam === 'false' ? false : null);
	const paramPage = searchParams.get('page') || 1;
	const pagination = {
		currentPage: data?.currentPage,
		pageSize: data?.itemsPerPage,
		totalItems: data?.totalItems,
	};

	const notification = useNotificationStore((state) => state.notifications);

	console.log('dataSource', dataSource);
	useEffect(() => {
		console.log('useEffect - init');
		console.log(('type', selectedNotificationType));
		new Service()
			.getNotificationsByCountry({
				page: paramPage,
				seen,
				token: user.token,
				pharmacy: selectedPharmacy,
				type: selectedNotificationType,
				order: orderBy,
			})
			.then((response) => {
				console.log('response', response);
				setData(response);
				setDataSource(response.data);
				setIsLoading(false);
				setForceRefetch(false);
			});
	}, [paramPage, seen, user, selectedPharmacy, selectedNotificationType, orderBy, forceRefetch]);

	useEffect(() => {
		console.log('useEffect - update dataSource from notifications');

		if (notification.length > 0) {
			setDataSource((prevDataSource) => {
				const existingIds = new Map(prevDataSource.map((item) => [item._id, true]));
				const newNotifications = notification.filter((item) => !existingIds.has(item._id));
				if (newNotifications.length === 0) {
					return prevDataSource;
				}
				return [...newNotifications, ...prevDataSource];
			});
		}
	}, [notification]);

	console.log('seen', seen);
	console.log('statusQueryParam', statusQueryParam);

	const handleToString = (searchParams) => {
		return searchParams.toString();
	};

	const handleLocation = (location) => {
		return location?.pathname;
	};

	const handlePageChange = (page) => {
		searchParams.set('page', page);
		history.push({
			pathname: handleLocation(location),
			search: handleToString(searchParams),
		});
	};

	const onTabChange = () => {
		searchParams.set('page', 1);
		history.push({
			pathname: handleLocation(location),
			search: handleToString(searchParams),
		});
	};

	console.log('selectedPharmacy', selectedPharmacy);
	console.log('notificationType', selectedNotificationType);

	// Agregado
	const handleFilterChange = (type, value) => {
		if (value === null) {
			setSelectedPharmacy(null);
			setSelectedNotificationType(null);
		} else {
			// Actualizar solo el filtro específico
			if (type === 'pharmacy') {
				setSelectedNotificationType(null);
				setSelectedPharmacy(value);
			} else if (type === 'notificationType') {
				setSelectedPharmacy(null);
				setSelectedNotificationType(value);
			}
		}

		// Reset a la primera página cuando se aplica un filtro
		searchParams.set('page', 1);
		history.push({
			pathname: handleLocation(location),
			search: handleToString(searchParams),
		});
	};

	const handleOrderChange = () => {
		setOrderBy((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
	};

	const handleMarkAsRead = (ids, markAsRead) => {
		console.log('notificationids', ids);
		new Service()
			.markNotificationsAsRead({
				ids,
				token: user.token,
				seen: markAsRead,
			})
			.then((response) => {
				setForceRefetch(true);
				if (!markAsRead) {
					removeNotificationsFromCache()
				}
			})
			.catch((error) => {
				console.error('Error al marcar notificaciones como leídas:', error);
			});
	};

	const tabOptions = tab(dataSource);
	const initialActiveTab = tabOptions.find((tab) => tab.seen === seen)?.key;

	const handleStatusQueryChange = (status) => {
		searchParams.set('seen', status);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<>
			<h2>Notificaciones </h2>
			<NotificationTable
				onPageChange={handlePageChange}
				initialActiveTab={initialActiveTab}
				onTabChange={onTabChange}
				tabOptions={tabOptions}
				data={dataSource}
				setSeen={setSeen}
				pagination={pagination}
				loading={isLoading}
				onFilterChange={handleFilterChange}
				onOrderChange={handleOrderChange}
				orderBy={orderBy}
				onMarkAsRead={handleMarkAsRead}
				isAdmin={user?.admin}
				onStatusChange={handleStatusQueryChange}
			/>
		</>
	);
}
